import axios, { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import { API_ENDPOINT } from '../utils/constants';
import { APIError } from '../utils/types';

// Using a loose type here because the exact OIDC client shape is defined on the backend.
// The UI accesses only a few commonly expected fields in a defensive way.
export type OidcClient = any;

const useOidcClients = () => {
  const fetchOidcClients = async () => {
    try {
      const {
        data: { data },
      } = await axios.get(API_ENDPOINT + '/oidc/clients');

      // Prefer data.clients if backend wraps list, otherwise fall back to data itself.
      return (data && (data.clients || data)) as OidcClient[];
    } catch (error: any) {
      throw error?.response?.data;
    }
  };

  return useQuery<OidcClient[], AxiosResponse<APIError>>(
    ['oidc_clients'],
    fetchOidcClients,
    {
      retry: false,
    }
  );
};

export default useOidcClients;



